import { render } from "./Footer.vue?vue&type=template&id=298f0d9f&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=298f0d9f&scoped=true&lang=css"

import exportComponent from "/home/syhpoon/UNIX/wealthpic/js/wealthpic-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298f0d9f"]])

export default __exports__